<template>
  <v-app style="margin-top:0px;" >
      <v-card flat v-bind:style="{ 'background-image': 'linear-gradient(to bottom,rgba(243, 177, 55, 0.73), rgba(58, 18, 18, 0.73)), url(' + banner + ')' }" class="tst">
          <v-container>
              <h1 style="margin-top:20px;">{{ countryName }}</h1>
          </v-container>
      </v-card>
<div class="container con" >
      <div class="row" style="margin-top:-100px; " >
        <div class="col-lg-9 col-md-9 col-sm-12" >
      <v-card flat style="border: 1px solid #b6b6b6;">
      <v-container>
          <div class="row" style="padding-top:20px;padding-left:15px;padding-right:15px;">
            <h2 class="country-heading m-2 " >WHY STUDY ABROAD IN {{ countryName }}</h2>
            <img :src="image" style="width: 50%;height:300px;" />
          <div class="col-lg-12 col-md-12 col-sm-12" style="color:grey;margin-top:50px;text-align: justify;">
            <h3 class="country-heading"><strong>Study in France</strong></h3>
            <p>In France, which has a semi-presidential system of government, the president, who is also the head of state and is directly elected, appoints the prime minister? 18 administrative regions make up France's territory: 13 metropolitan (also known as European France) and 5 abroad. Saint-Martin, a French colony in the Caribbean, and all five of the overseas territories are seen as belonging to the EU (with the status of outermost region). One of the three official locations of the European institutions is the French city of Strasbourg. Brussels and Luxembourg City are the other two. Public administration, defense, human health, and social work activities accounted for 23.4% of France's GDP in 2020, followed by wholesale and retail trade, transportation, lodging, and food services (16.4%), professional, scientific, and technical activities (14.2%), and administrative and support service activities (14.2%).54% of France's exports are for intra-EU commerce (Germany 15%, Italy 8%, Belgium and Spain 7%), 8% are for extra-EU trade, and 6% are for extra-EU trade with the United States and the United Kingdom.66% of imports originate from EU member states (Germany 17%, Belgium 10%, and the Netherlands 9%), whereas 7% and 5% of imports from outside the EU, respectively, are from China and the United States.</p>
            <p>Why to study in France?</p>
            <p><strong>Meeting people is the main focus of student life in France.</strong></p>
            <p>The French and international students, faculty, and staff of your host university will make your time there unforgettable. While you are here studying, you will discover all the benefits France has to offer. The many services provided by French institutions make life as a student simpler.</p>
            <p>This academic stay in France will be beneficial for your future career. You will graduate with critical information that is supported by certification from an accredited organization.</p>
            <h4 class="country-heading"><strong>A COUNTRY TO VISIT When YOU'RE THERE</strong></h4>
            <p>Outside of the classroom, a remarkable personal journey is in store. It's not only about the academics when you come to study in France. You may swim in three seas, three oceans, and tour four continents in France and its overseas territories.</p>
            <p>Explore five mountainous European areas over two continents. Moreover, the 42 UNESCO World Heritage sites are not included. All of this is located in the middle of an accessible continent.</p>
            <p>Throughout your academic time in France, you will create priceless experiences and develop relationships that you will treasure forever as a member of the sizable French alumni network.</p>
            <h4 class="country-heading"><strong>A RECOGNIZED INTERNATIONAL SYSTEM OF HIGHER EDUCATION</strong></h4>
            <p>The world is well aware of France's prowess in research and higher education. The Times Higher Education, the Financial Times, the QS, the Shanghai, and the European Union's U-Multibank are just a few of the highly regarded worldwide rankings that feature several French institutions and Grandes Ecoles. Studying in France entitles you to the advantages of this recognition.Its fame is particularly attributable to the outstanding accomplishments of French scientists. France is ranked second in the world for mathematics with thirteen Fields Medals. In addition, it has produced 62 Nobel laureates, including Marie Curie. She was the first person in the world to get a second Nobel Prize for research for chemistry in 1911 after being awarded one for physics in 1903, making history.</p>
            <h4 class="country-heading"><strong>A WORLDWIDE EXPORT OF INDUSTRIAL DYNAMISM</strong></h4>
            <p>The fifth-largest economy in the world and 31 of the 500 most powerful corporations are all located in France. Some French industrial conglomerates, such as Airbus, Total, Orange, Sanofi, LVMH, L’Oreal, and DANONE, are market leaders with a global presence in their respective industries. A WORLDWIDE EXPORT OF INDUSTRIAL DYNAMISM.</p>
            <h4 class="country-heading"><strong>THE EXPLOITATION OF FRENCH INNOVATION</strong></h4>
            <p>The ranking of the top 100 most innovative enterprises has the best representation of France among all European nations. It is home to 71 competitiveness clusters, which together provide an appealing environment and bring together research facilities, academic institutions, start-up businesses, and large organizations. With an investment of 200 million Euros, French Tech fosters the growth of digital businesses and draws in young talent.</p>
            <p>We take pride in having produced three Nobel laureates in economics, thirteen in physics, and fifteen in literature. The Fields Medal has been awarded to 13 French mathematicians. In terms of the overall number of filed foreign patents, France is sixth in the world.</p>
            <h4 class="country-heading"><strong>A HIGH STANDARD OF VARIED CRAFTMANSHIP</strong></h4>
            <p>France is a global leader in several specialized disciplines, especially arts and crafts and upscale industries like jewellery, couture, crystal glassmaking, and architecture, with 40,000 workshops and 100,000 artisans. In France, design-based industrial innovation is particularly well-established.</p>
            <h3 class="country-heading"><strong>Study Process in France</strong></h3>


          <p>It goes without saying that one must complete the application in its full if he/she chooses to apply to a college in France. The quicker users complete this, the quicker the admissions committee can assess it and determine if users’re a suitable fit for the institution. The following are the required documents when to apply for the colleges in France(For non EU students):</p>
          <ul>
             <li>Filled out a college application</li>
             <li>Transcripts from high school and from college (you just need the high school ones if you didn't go to college).</li>
             <li>Passport photocopy</li>
             <li>The size of a passport</li>
             <li>Essay (if asked) (if asked)</li>
             <li>Results for English proficiency (TOEFL, IELTS, Duolingo etc.)</li>
             <li>Birth certificate copy</li>
             <li>Certified translation of your parents' places of birth</li>
             <li>evidence that you are financially capable</li>
             <li>any other paperwork that could be requested by the university</li>
             <li>Upon admission a student visa for France</li>
          </ul>
          <p>What is the need of visa?</p>

          <h3 class="country-heading"><strong>Is a Student Visa Required?</strong></h3>
          <p>Here is what you'll need to get a student visa if you're not a student from Europe:</p>
          <p>A letter of acceptance from a French institution with accreditation. This should be written on letterhead and include information on your course of study, including the beginning and ending dates.</p>
          <p>Evidence that you can support yourself while visiting France. Now, €615 per month is required, which may be verified by a bank statement, a letter from a guarantor, or a notification of financing through a loan, scholarship, or grant.</p>
          <p>Evidence of a return flight home. This frequently takes the shape of a ticket or reservation that shows the departure date, but it can also take the form of a handwritten declaration of purpose that also includes anticipated departure dates.</p>
          <p>Evidence of health insurance (minimum €30,000 coverage)</p>
          <p>Evidence of accommodations. If you're living with friends or family, you can demonstrate this by showing a "attestation d'accueil" or a certificate of board and lodging.</p>
          <p>If you are enrolled in a French-language course, documentation proving your language ability.</p>
          <p>Some popular UG courses in France and the required documents:</p>

          <div class="body table-responsive">
                    <table class="table table-bordered" style="margin-top: 10px;">
                        <thead>
                          <tr style="background-color: #f48d8d;">
                            <th style="text-align: center;">PSL University</th>
                            <th style="text-align: center;">47(Times Higher Education ranking)</th>
                            <th style="text-align: center;">26(QS World ranking)</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td >Institute of Polytechnique de Paris</td>
                            <td style="text-align: center;">90</td>
                            <td style="text-align: center;">60</td>
                          </tr>
                          <tr>
                            <td >Sorbonne University</td>
                            <td style="text-align: center;">90</td>
                            <td style="text-align: center;">60</td>
                          </tr>
                          <tr>
                            <td >University of Paris-Saclay</td>
                            <td style="text-align: center;">93</td>
                            <td style="text-align: center;">69</td>
                          </tr>
                          <tr>
                            <td >ENS Lyon</td>
                            <td style="text-align: center;">301-350</td>
                            <td style="text-align: center;">111</td>
                          </tr>
                          <tr>
                            <td >Ecole Des Ponts ParisTech</td>
                            <td style="text-align: center;">251-300</td>
                            <td style="text-align: center;">174</td>
                          </tr>
                          <tr>
                            <td >Paris Cite University</td>
                            <td style="text-align: center;">114</td>
                            <td style="text-align: center;">248</td>
                          </tr>
                          <tr>
                            <td >University of Grenoble Alpes</td>
                            <td style="text-align: center;">401-500</td>
                            <td style="text-align: center;">317</td>
                          </tr>

                        </tbody>
                      </table>
          </div>

    
          <h4 class="country-heading"> <strong>Courses Best French</strong></h4>
              <p>A cost-effective alternative for overseas students is to study in France. Certain business courses are ideal to take in France, but there are other courses that have recently gained a lot of popularity. The following are some of the top programs in France:</p>
               <ul>
                <li>MBA \engineering</li>
                <li>Film studies on luxury brand management</li>
                <li>Hotel Administration Fashion Design</li>
                <li>Finance and Computer Science</li>
                <li>Science Data Medicine</li>
                <p>Some popular Mba college in France:</p>
                <li>INSEAD</li>
                <li>HEC Paris</li>
                <li>ESSEC Business School</li>
                <li>Grenoble Graduate School of Business</li>
                <li>EDHEC Business School</li>

               </ul>
               <p>Studying in France is relatively inexpensive in public higher education institutions since the French government funds higher education. Students from outside the EU must pay separate registration costs. The two-thirds of the cost of your training will be covered by the state. Students must pay a total differentiated registration cost of:</p>
               <ul>
                <p>At the bachelor's level, $2,770 is paid annually.</p>
                <p>At the master's level, €3,770 is paid annually.</p>
               </ul>

               <h4 class="country-heading"> <strong>Visa Application Process in France:</strong></h4>
               <p><strong>Student Visa for France</strong></p>
               <p>There are many sorts of France student visas available for studying there. Students are permitted to enter and stay in France inside the Schengen region for a maximum of 90 days with a Schengen short-stay visa. Students who have a temporary long-term visa can enroll in higher education courses for 4 to 12 months.</p>
               <p>On the other hand, students can use their long-stay visa as a residency permit. This visa enables students to stay in France for a period of four to twelve months in order to complete their higher education. When a student's VLS-TS visa is set to expire, they can petition to have it renewed if they still wish to stay in France to finish their studies. Students may work 964 hours a year with this visa.</p>
               <h4><strong>Scholarships for French Universities</strong></h4>
               <p>Scholarships for overseas students to study in France are offered on the basis of merit and need. Students will be eligible for scholarships and financial aid if they have great academic records, strong test scores, and extracurricular accomplishments. Make sure to apply before the deadline if you want to take full advantage of these chances.</p>
               <p>Students can apply for scholarships granted by French higher education institutions such the Emile-Boutmy Scholarships at Science Po, the Rennes Business School, and the EDHEC Business School. Also, according to Campus France, the French Government offers more than 500 scholarships to deserving Indian students who wish to pursue higher education in France. The expense of the tuition must be met. Students have the option of applying for an educational loan in order to pay for their tuition, living expenses, and other costs in France. Banks thus provide educational loans for studying in France.</p>
               <p>It is advisable to have all the necessary paperwork prepared in advance and to satisfy all eligibility requirements in order to receive rapid approval for a student loan. An educational loan may help with costs like as tuition, room and board, exams, lab and library fees, books, equipment like computers, uniforms, and caution deposits, as well as additional costs necessary to finish the course, including project work, study trips, or thesis.</p>
               <h4 class="country-heading"> <strong>Popular French Job Sectors/Job emplobility</strong></h4>
               <p>According to the Organization for Economic Co-operation and Development, France's real GDP is expected to increase by 2.6% in 2022 and 0.6% in 2023. (OECD). According to the Economic Report from November 2021, the French economy swiftly recovered from the COVID-19 disaster. France's top industries for employment include:</p>
               <ul>
                <li>Automotive, aerospace, mechanical, and metallurgy management engineering</li>
                <li>Educating about tourism, hospitality, and luxury energy management</li>
                <li>Jobs that are in high demand in France</li>
                <li>Medical / Medical Attorneys</li>
                <li>Pilots in the healthcare industry</li>
                <li>Banker professor of higher education</li>
                <li>IT specialists</li>
                <li>A few multinational corporations based in France are:Airbus,L’Oreal,Sanofi,France Air,Danone,ABN Amro,Total Energies,Dior etc.</li>
               </ul>
               <h4 class="country-heading"> <strong>Career Opportunity in France (ROI)</strong></h4>
               <p>The return on their investments is a constant concern in the thoughts of students who choose to study abroad. The best return on their investment is what students want. While opting to remain abroad, students weigh several factors, including the high expense of studying abroad and the potential for a good return on investment.Health and social care, wholesale and retail commerce, and manufacturing are the three industries that account for the majority of employment in France, according to the European Centre for the Promotion of Vocational Training. In the years to come, France is anticipated to do better thanks to a stronger increase in the number of people who are employed and of working age.</p>

           
          </div>     
        </div>
        </v-container>
    </v-card>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-12">
          <v-card flat style="background-size:cover;padding:30px;border: 1px solid #b6b6b6;">
                  <div style="background-color:black;color:white;text-align:center;padding:10px;background-image: linear-gradient(to right, #f19a28 , #f12525);background-size:cover;">
                      <h3>Interested in studying abroad?</h3>
                  </div>
                  <v-container v-if="otp==false">
                      <v-form ref="form" v-model="valid" lazy-validation>
                          <v-layout row wrap >
                              <v-flex xs12 style="padding-top:10px;" >
                                  <v-text-field outline style="background-color:white;height:70px;border-radius:10px;padding: 15px;" v-model="form.name" label="Full Name *" :rules="emptyRule" required></v-text-field>
                              </v-flex>
                              <v-flex xs12 style="padding-top:10px;">
                                  <v-text-field outline style="background-color:white;height:70px;border-radius:10px;padding: 15px;"  v-model="form.email" label="Email *" :rules="[rules.email]" required></v-text-field>
                              </v-flex>
                              <v-flex xs12 style="padding-top:10px;">
                                  <v-text-field outline style="background-color:white;height:70px;border-radius:10px;padding: 15px;"  v-model="form.mobileNumber" label="Mobile No *" :rules="[rules.mobileno]" required></v-text-field>
                              </v-flex>
                              <v-flex xs12 style="padding-top:10px;">
                                  <v-autocomplete
                                   outline 
                                   style="background-color:white;height:70px;border-radius:10px;padding: 15px;" 
                                   v-model="selectedCountry"
                                   :items="countries"
                                   color="primary"
                                   label="Preferred Country *"
                                   item-text="countryName"
                                   item-value="countryName"

                                  ></v-autocomplete>
                              </v-flex>
                              <v-flex xs12 style="padding-top:10px;">
                                  <v-autocomplete
                                   outline 
                                   style="background-color:white;height:70px;border-radius:10px;padding: 15px;" 
                                   v-model="selectedCourse"
                                   :items="courses"
                                   color="primary"
                                   label="Preferred Course *"
                                   item-text="courses"
                                   item-value="courses"
                                  ></v-autocomplete>
                              </v-flex>
                              <v-flex xs12 style="padding-top:10px;text-align:center;">
                                  <v-btn :loading="btnSave" large block dark color="primary" @click="getOtp()">Send Message</v-btn>
                              </v-flex>
                          </v-layout>
                      </v-form>
                  </v-container>

                  <v-container v-if="otp==true">
                      <v-form ref="form1" v-model="valid" lazy-validation>
                          <v-layout row wrap>
                              <v-flex xs12>
                                  <label>Enter Your OTP here *</label>
                                  <v-text-field outline style="background-color:white;height:56px" v-model="form1.pin" label="Enter Your OTP here *" :rules="emptyRule" required></v-text-field>
                              </v-flex>
                              <v-flex xs12 style="padding-top:10px;text-align:center;">
                                  <v-btn :loading="btnSave1" large block dark color="primary" @click="onSubmit()">Vefity Now</v-btn>
                              </v-flex>
                          </v-layout>
                      </v-form>
                  </v-container>
          </v-card>
          <v-card flat style="background-size:cover;padding:30px;border: 1px solid #b6b6b6; margin-top: 10px;">
            <div style="background-color:black;color:white;text-align:center;padding:10px;background-image: linear-gradient(to right, #f19a28 , #f12525);background-size:cover;">
                      <h3>Universities</h3>
                  </div>
             <marquee direction="up" scrollamount="3" style="margin-top:20px;height:150px ; ">
               <h5 style="margin-bottom:20px;color:#f12525" v-for="item in featuredUniversities" :key="item.id">{{ item.universityName }}</h5>

             </marquee>
          </v-card>

              <div class="">
                <h2 class="m-4" >Global Study <span style="font-weight:600">Destinations</span></h2>
              </div>
            <v-card @click="onCountry(item)" v-for="item in countries" :key="item.id" elevation="10" :style="{backgroundImage: `url(${item.image})`}" class="tourtheme hvr mb-3">
              <div style="margin:0px;cursor: pointer; ">
                <h4 class="mytxt" style="color:whitesmoke;padding:5px;margin:-10px;border-radius: 0px;margin-top: 125px;">{{ item.countryName }}</h4>
              </div>
            </v-card>

        </div>
      </div>
    </div>
      <v-dialog v-model="dialog" width="500px" persistent>
         <v-card>
           <div style="height:150px;background-color:green;text-align:center;">
             <div style="padding-top:25px;">
                <v-icon style="border:1px solid;border-radius:50px;border-color:white;" color="white" :size="80">check</v-icon>
             </div>
           </div>
           <v-container>
             <div style="text-align:center">
                 <h4>Thank You</h4>
                 <h5 class="txt" style="padding-bottom:15px;">Our Counsellors will get back to you !!</h5>
                 <v-btn depressed large color="error" @click="cancel()">Yes Understand</v-btn>
             </div>
           </v-container>
         </v-card>
     </v-dialog>
  </v-app>
</template>

<script>
import config from "../../config.json";
import moment from 'moment';
export default {
  components: {
  },
  data() {
    return {
      tab: null,
      valid: true,
      btnSave: false,
      btnSave1: false,
      dialog: false,
      status: false,
      pin: 0,
      otp: false,
      name: [],
      featuredUniversities: [],

      ielts: true,
      toefl: false,
      gre: false,
      sat: false,
      gmat: false,

      details: null,
      image: null,
      banner: null,
      countryId: null,
      countryName: sessionStorage.getItem("countryName"),

      countries: [],
      selectedCountry: null,

      courses: [],
      selectedCourse: null,

      form: {
        name: null,
        email: null,
        mobileNumber: null
      },
      form1: {
        otp: null
      },
      emptyRule: [v => !!v || "Input is required"],
      rules: {
        required: value => !!value || "Required.",
        email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid e-mail.";
        },
        mobileno: value => {
          const pattern = /^[1-9]{1}[0-9]{9}$/;
          return pattern.test(value) || "Mobile number not valid!!";
        },
      },
    };
    
  },
  
   mounted() {
    // this.axios
    //     .get(config.API + `country/author/${this.$route.params.id}`, {
    //       headers: {
    //         Authorization: "bearer " + sessionStorage.getItem("token")
    //       }
    //     })
    //     .then(res => {
    //       let _data = res.data.author;
    //       this.details = _data;
          
    //       if(_data.image!=null) {
    //         this.image = config.API + 'country/files1/' + _data.image;
    //       }
    //       if(_data.banner!=null) {
    //         this.banner = config.API + 'country/files2/' + _data.banner;
    //         console.log(this.banner);
    //       }
    //     })
    //     .catch(() => {
    //       this.$Progress.fail();
    //     });

      this.countryName = sessionStorage.getItem("countryName");
      this.image = sessionStorage.getItem("image");
      this.banner = sessionStorage.getItem("banner");
      this.countryId = sessionStorage.getItem("countryId");
        this.axios
      .get(config.API + `country/authors`, {
        headers: { Authorization: "Bearer " + sessionStorage.token }
      })
      .then(res => {
        let list = res.data.authors;
        console.log(list);

        for (let index = 0; index < list.length; index++) {
          const element = list[index];
          if(element.id!=this.countryId) {
            this.countries.push({
            id: element.id,
            countryName: element.countryName.toUpperCase(),
            src: config.API1 + "country/files/" + element.src,
            image: config.API1 + "country/files1/" + element.image
            })
          }
        }

        console.log(this.countries);
      });

      this.axios
    .get(`https://api.worldwin.org/api/Levels`, {
      headers: { Authorization: "Bearer " + sessionStorage.token }
    })
    .then(res => {
      let list = res.data;
      for (let index = 0; index < list.length; index++) {
        const element = list[index];
        
        this.courses.push(element.levelName)
      }
    });


    this.axios
        .post(
          config.API + `university/search`,
          {
            countryId: this.countryId
          },
          {
            headers: {
              Authorization: "bearer " + sessionStorage.getItem("token")
            }
          }
        )
        .then(res => {
          let list = res.data.result;
          console.log(list);

          for (let index = 0; index < list.length; index++) {
            const element = list[index];
            
            this.featuredUniversities.push({
              id: element.id,
              universityName: element.universityName,
              src: config.API1 + "university/files/" + element.src
            })
          }
            })
        .catch(err => {
        });
   },

 methods: {
   blg(item) {
     sessionStorage.setItem("blogTitle", item.title);
     sessionStorage.setItem("blogDescription", item.description);
     sessionStorage.setItem("blogSrc", item.src);
     this.$router.push("/blogDetail/" + item.id );
   },
   getOtp() {
    if (this.$refs.form.validate()) {
      this.btnSave = true;
      this.axios
        .post(
          config.API + `enquiry/author`,
          {
            name: this.form.name,
            email: this.form.email,
            mobileNumber: JSON.parse(this.form.mobileNumber),
            country: this.selectedCountry,
            course: this.selectedCourse,
            page: 'Country Details',
            date: moment().format('MMMM Do YYYY')
          },
          {
            headers: {
              Authorization: "bearer " + sessionStorage.getItem("token")
            }
          }
        )
        .then(res => {
          console.log(res);
          this.name = this.form.name.split(' ');
          let firstName = this.name[0];
          let lastName = null;

          if(this.name.length > 2) {
            lastName = this.name[1] + this.name[2]
          }
          else {
            lastName = this.name[1]
          }

          let comment = "Preferred Country: " + this.selectedCountry + ", Preferred Course: " + this.selectedCourse;
          this.axios
        .post(
          `https://api.worldwin.org/api/Leads1`,
          {
            firstName: firstName,
            lastName: lastName,
            mobileNumber: JSON.parse(this.form.mobileNumber),
            cmsId: JSON.parse(res.data.result.id),
            email: this.form.email,
            guardianName: null,
            comment: comment,
            pageName: 'Country Details',
            guardianNo: 0,
            guardianEmail: null,
            relation: null,
            address: null,
            nature: null,
            source: "Website",
            document: false,
            documentType: null,
            notes: null,
            levelId: 0,
            leadDetails: null,
            leadTrainings: null
          },
          {
            headers: {
              Authorization: "bearer " + localStorage.getItem("token")
            }
          }
        )
        .then(res => {
          this.dialog = true;
          this.btnSave = false;
        })
        .catch(() => {
          this.$toaster.error(`Mobile no is already registered`);
          this.btnSave = false;
        });
        })
        .catch(() => {
          this.$toaster.error("Mobile no is already registered");
          this.btnSave = false;
        });
      }
      /* this.pin = Math.floor(1000 + Math.random() * 9000);
      this.axios
        .post(
          config.API + 'enquiry/otp',
          {
            name: this.form.name,
            mobileNumber: JSON.parse(this.form.mobileNumber),
            otp: this.pin
          },
          {
            headers: {
              Authorization: "bearer " + sessionStorage.getItem("token")
            }
          }
        )
        .then(() => {
          this.otp = true;
          this.btnSave = false;
        })
        .catch(() => {
          this.$toaster.error("Mobile number already exists!!");
          this.btnSave = false;
        }); */
    /* } else {
      this.$toaster.error(`Required field are empty!!`);
    } */
  },
  onCountry(item) {
  sessionStorage.setItem("countryName", item.countryName);
  sessionStorage.setItem("image", item.image);
  sessionStorage.setItem("banner", item.banner);
  sessionStorage.setItem("countryId", item.id); 
  ////this.$router.push("/countrydetail/" + item.id );
  if(item.countryName=='UK') {
    this.$router.push("/study-in-uk");
  }
  else if(item.countryName=='DUBAI') {
    this.$router.push("/study-in-dubai");
  }
  else if(item.countryName=='SINGAPORE') {
    this.$router.push("/study-in-singapore");
  }
  else if(item.countryName=='USA') {
    this.$router.push("/study-in-usa");
  }
  else if(item.countryName=='AUSTRALIA') {
    this.$router.push("/study-in-australia");
  }
  else if(item.countryName=='CANADA') {
    this.$router.push("/study-in-canada");
  }
  
 },

    onSubmit() {
      if (this.$refs.form1.validate()) {
        if(this.pin == this.form1.otp) {
          this.btnSave1 = true;
        this.axios
          .post(
            config.API + `enquiry/author`,
            {
              name: this.form.name,
              email: this.form.email,
              mobileNumber: JSON.parse(this.form.mobileNumber),
              country: this.selectedCountry,
              course: this.selectedCourse,
              page: 'Test Preparation',
              date: moment().format('MMMM Do YYYY')
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(res => {
            console.log(res);
            this.name = this.form.name.split(' ');
            let firstName = this.name[0];
            let lastName = null;

            if(this.name.length > 2) {
              lastName = this.name[1] + this.name[2]
            }
            else {
              lastName = this.name[1]
            }
            this.axios
          .post(
            `http://api.worldwin.org/api/Leads1`,
            {
              firstName: firstName,
              lastName: lastName,
              mobileNumber: JSON.parse(this.form.subject),
              cmsId: JSON.parse(res.data.result.id),
              email: this.form.email,
              guardianName: null,
              guardianNo: 0,
              guardianEmail: null,
              relation: null,
              address: null,
              nature: null,
              source: null,
              document: false,
              documentType: null,
              notes: null,
              levelId: 0,
              leadDetails: null,
              leadTrainings: null
            },
            {
              headers: {
                Authorization: "bearer " + localStorage.getItem("token")
              }
            }
          )
          .then(res => {
            this.dialog = true;
            this.btnSave1 = false;
          })
          .catch(() => {
            this.$toaster.error(`Mobile no is already registered`);
            this.btnSave = false;
          });
          })
          .catch(() => {
            this.$toaster.error("Mobile no is already registered");
            this.btnSave1 = false;
          });
        }
        else {
          this.$toaster.error("Please put a valied OTP");
        }
      } else {
        this.$toaster.error(`Required field are empty!!`);
      }
    },

    cancel() {
      this.form.name = null;
      this.form.email = null;
      this.form.mobileNumber = null;
      this.otp = false;
      this.dialog = false;
    },
 }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Nanum+Gothic&display=swap');
@import url('https://fonts.googleapis.com/css?family=Montserrat|Space+Mono&display=swap');
@import url('https://fonts.googleapis.com/css?family=Anton&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Lexend+Tera&family=Open+Sans:wght@600&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Metal+Mania&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Patua+One&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Galada&family=Modak&family=Roboto&family=Roboto+Mono:ital,wght@1,600&display=swap');
</style>

<style scoped>
.banner {
  background-image: url('https://www.pexels.com/photo/selective-focus-photo-of-man-using-laptop-1438081/');
  background-size: cover;
  height:200px;
}
.tst {
  border-radius:0px;
  height:300px;
  background-size: cover;
  color: white !important;
    
}
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: .5;
  position: absolute;
  width: 100%;
}
.tourtheme {
  height: 190px;
  margin: 15px;
  background-size: 100%;
  transition: background-size 1s ease-in-out !important;
}
.tourtheme:hover {
  background-size: 120%;
}
.partner {
    margin-top: 15px;
    text-align: center;
    font-size: 23px;
    background-image: linear-gradient(to right, #f19a28 , #f12525);
    border-radius: 0px !important;
    color: whitesmoke !important;
}
.country-heading {
  color:#EC1616;
}
.country p {
  font-weight: 300;
  color:#666666;
  text-align: justify;
}
.v-card {
  padding: 10px;
  border-radius: 8px;
}
.v-sheet--offsets {
  top: -50px;
  position: relative;
}
.v-sheet--offset {
  top: -30px;
  position: relative;
}
.v-sheet--offsetf {
  top: -100px;
  position: relative;
}
.swo {
  box-shadow: none !important;
}
.opa {
  opacity: 1;
}
div.scroll { 
                margin:4px, 4px; 
                padding:4px; 
                width: auto; 
                height: 254px; 
                overflow-x: hidden; 
                overflow-x: auto; 
                text-align:justify; 
            }

.themecap {
  font-family: 'Open Sans', sans-serif;
  padding-top: 130px;
  color: white;
}
.top-left {
  font-family: 'Roboto Mono', monospace;
  font-size:40px ;
  padding-top: 200px;
  color: white;
  text-align: center;
}
.salont {
  font-family: 'Patua One', cursive;
}
.link:hover {
  cursor: pointer;
  text-decoration: underline;
}
.hvr:hover {
  cursor: pointer;
  border-radius: 5px !important;
  border : 1px solid;
  border-color: black !important;
  transition-duration: 0.7s;
  text-decoration: none !important;
}
.v-table tbody tr:not(:last-child) {
    border-bottom: none !important;
}
.con {
  margin-top: -100px;
  max-width: 1300px;
}
@media screen and (min-width: 768px){
  .con {
    margin-top: 0px!important;}

  }
@media screen and (max-width: 768px) {
  .res {
    display: none;
  }
}
@media screen and (min-width: 768px){
  .man {
    display: none;
  }
}
img.center {
    display: block;
    margin: 0 auto;
}
.recent {
  font-family: 'Nanum Gothic', sans-serif;
}
.srch {
  position: absolute;
  z-index: 10;
  left: 16%;
  top: 0%;
}
.item {
    border:1px solid !important;
}
</style>
